import React from 'react'
import { Box, Divider, Stack, TextField, Typography } from '@mui/material'
import HeroBannerSettings from './settings/HeroBannerSettings'
import ContentBlockSettings from './settings/ContentBlockSettings'
import CollectionSettings from './settings/CollectionSettings'
import FeaturedProductSettings from './settings/FeaturedProductSettings'
import ProductCatalogSettings from './settings/ProductCatalogSettings'
import CategoryTilesSettings from './settings/CategoryTilesSettings'
import { getSectionLabel } from './sectionRegistry'
import useTranslation from '../../hooks/useTranslation'

const SETTINGS_COMPONENTS = {
  heroBanner: HeroBannerSettings,
  contentBlock: ContentBlockSettings,
  collection: CollectionSettings,
  featuredProduct: FeaturedProductSettings,
  productCatalog: ProductCatalogSettings,
  categoryTiles: CategoryTilesSettings,
}

const normalizeCssKey = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s_-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')

export default function SectionSettings({
  section,
  themeId,
  onChange,
  onRefreshPreview,
}) {
  const { t } = useTranslation()
  const SettingsComponent = SETTINGS_COMPONENTS[section.type]

  if (!SettingsComponent) {
    return (
      <Box>
        <Typography color="text.secondary">
          No settings editor for section type: {section.type}
        </Typography>
      </Box>
    )
  }

  const handleCssKeyChange = (event) => {
    onChange({
      ...section.settings,
      cssKey: normalizeCssKey(event.target.value),
    })
  }

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        {getSectionLabel(section.type)}
      </Typography>

      <SettingsComponent
        settings={section.settings}
        sectionId={section.id}
        themeId={themeId}
        onChange={onChange}
        onRefreshPreview={onRefreshPreview}
      />

      <Divider sx={{ my: 3 }} />

      <Stack spacing={0.5}>
        <TextField
          label={t('labels.themes.sectionCssKey')}
          size="small"
          fullWidth
          value={section.settings?.cssKey || ''}
          onChange={handleCssKeyChange}
          helperText={t('labels.themes.sectionCssKeyInlineHelp')}
        />
      </Stack>
    </Box>
  )
}
